
import Html3 from "../../../assets/filled/Html3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Html3Icon({ className, dataTestid = "Html3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Html3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
